module.exports = __webpack_public_path__ + "img/menu-down.b7ea5e2c.svg";